import React, { useState } from "react";
import { motion } from "framer-motion";
import "./Contact.css";

import Whatsapp from "../../../assets/logo/whatsapp.png";
import Gmail from "../../../assets/logo/gmail.png";
import Linkedin from "../../../assets/logo/linkedin.webp";
import Facebook from "../../../assets/logo/facebook.webp";
import Instagram from "../../../assets/logo/instagram.webp";
import Youtube from "../../../assets/logo/youtube.webp";

const Contact = () => {
  const WHATSAPP_NUMBER = "919810044015";
  const SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbzk5BWGnuKiHcd4YB9WCiugFW0orbeN_6AI04KTOvgz9y5igMTFFclMTTJXX4pAZPLa/exec";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };
const [showThankYou, setShowThankYou] = useState(false);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    // ✅ WhatsApp message
    const whatsappMessage = `
Hello Team,

I would like to contact you.

👤 Name: ${formData.name}
📧 Email: ${formData.email}
📞 Phone: ${formData.phone}
🏢 Company: ${formData.company}

💬 Message:
${formData.message}

Thank you!
    `;

    // ✅ Open WhatsApp
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
        whatsappMessage
      )}`,
      "_blank"
    );

    // ✅ Save to Google Sheet
fetch(SCRIPT_URL, {
  method: "POST",
  mode: "no-cors",
  body: JSON.stringify({
    Name: formData.name,
    Email: formData.email,
    Phone: formData.phone,
    Company: formData.company,
    Message: formData.message,
  }),
})
.then(() => {
  setShowThankYou(true); 
          setStatus("");
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          message: "",
        });
      })
      .catch(() => {
  setStatus("Something went wrong. Please try again.");
});
  };

  return (
    <div className="container contact-page">
      <h1 className="text-center">Contact Us</h1>
      <p className="text-center mb-4">
        Have a question or looking to collaborate? Reach out to us and our team
        will get back to you within 24 hours.
      </p>

      <div className="contact-section">
        <div className="row g-4">
          {/* CONTACT FORM */}
          <div className="col-lg-6">
            <motion.form
              onSubmit={handleSubmit}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="contact-form"
            >
              <h3>Send Message</h3>

              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  id="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  id="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Phone</label>
                <input
                  type="tel"
                  id="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Company</label>
                <input
                  type="text"
                  id="company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea
                  id="message"
                  rows="4"
                  required
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

              <button type="submit" className="btn-submit">
                Send Message
              </button>

              {status && <p className="status-text">{status}</p>}
            </motion.form>
          </div>

          {/* CONTACT INFO */}
          <div className="col-lg-6">
            <motion.div
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <motion.div variants={fadeInUp}>
                <div className="contact-info-card py-3">
                  <h3>Contact Us</h3>
                  <div className="social-icons">
                    <a
                      href="https://wa.me/919810044015"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={Whatsapp} alt="whatsapp" className="social-logo" />
                    </a>

                    <a href="mailto:ihnexperience@gmail.com">
                      <img src={Gmail} alt="gmail" className="social-logo" />
                    </a>
                  </div>
                </div>
              </motion.div>

              <motion.div variants={fadeInUp}>
                <div className="contact-info-card mt-5 py-3">
                  <h3>Follow Us</h3>
                  <div className="social-icons">
                    <a href="https://www.linkedin.com/company/indianhospitalitynetwork/" target="_blank" rel="noreferrer">
                      <img src={Linkedin} alt="linkedin" className="social-logo" />
                    </a>
                    <a href="https://www.instagram.com/indianhospitalitynetwork/" target="_blank" rel="noreferrer">
                      <img src={Instagram} alt="instagram" className="social-logo" />
                    </a>
                    <a href="https://www.facebook.com/indianhospitalitynetwork/" target="_blank" rel="noreferrer">
                      <img src={Facebook} alt="facebook" className="social-logo" />
                    </a>
                    <a href="https://www.youtube.com/@ihntv-li7bc" target="_blank" rel="noreferrer">
                      <img src={Youtube} alt="youtube" className="social-logo" />
                    </a>
                  </div>
                </div>
              </motion.div>

              <motion.div variants={fadeInUp}>
                <div className="contact-info-card mt-5 py-3">
                  <h3>Locate Us</h3>
                  <iframe title="Location Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.564564556!2d77.2273!3d28.6129!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM2JzQ2LjQiTiA3N8KwMTMnMzguMyJF!5e0!3m2!1sen!2sin!4v1625555555555" width="100%" height="250" style={{ border: 0 }} allowFullScreen="" loading="lazy" ></iframe>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
     {showThankYou && (
  <div className="whatsapp-thank-you-overlay">
    <div className="whatsapp-thank-you-container">
      
      {/* ❌ CLOSE ICON */}
      <button
        className="popup-close"
        onClick={() => setShowThankYou(false)}
      >
        ✕
      </button>

      <div className="fs-2">✅</div>

      <h3 className="whatsapp-thank-you-title">Request Received!</h3>

      <p className="whatsapp-thank-you-msg text-center">
        Thank you for reaching out.
        <br />
        Our team will contact you within <strong>two working days</strong>.
      </p>

      <a
        href="https://wa.me/919810044015"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-cta"
      >
        <img src={Whatsapp} alt="WhatsApp" />
        Chat with us on WhatsApp
      </a>
    </div>
  </div>
)}
    </div>
    
  );
};

export default Contact;